<template>
    <div>
        <div v-if="loading > 0" class="fa-3x text-center">
            <i class="fas fa-spinner fa-pulse" style="color:#91ccda;"></i>
        </div>
        <div v-else>
            <BTabs v-model="tabIndex" no-fade>
                <BTab v-for="module in modules" :key="module.id" :title-link-class="'bg-' + module.color">
                  <template #title>
                    <span :class="'module-icons ' + module.icon + ' bg-' + module.color"></span>
                  </template>

                  <content-container :module="module">
                    <slot :module="module" name="primary"></slot>
                  </content-container>

                  <slot :module="module" name="secondary"></slot>
                </BTab>
              </BTabs>
        </div>
    </div>
</template>

<script>
    import ContentContainer from './ContentContainer'

	export default{
        components: {
            ContentContainer,
        },
        props: {
            modules: {
                required: true,
                type: Array
            },
            activeIndex: {
                type: Number,
                default: 0
            }
        },
		data(){
			return {
	            assessments: [],
                loading: 0,
                tabIndex: this.activeIndex
			}
        },
		methods: {

		}
	}
</script>